import { createReducer, on } from '@ngrx/store';
import { Constants, StwProcessCode } from '../../shared/utilities/Constants';
import { ConfirmationPageActions, InternalTransferActions, InternalTransfersActions, PositionsTableActions, ReviewPageActions, TransactionFormActions } from '../actions';
import { ComponentStateById, InternalTransfersInfo, RecurringFieldsById, IraFieldsById, ToAccountProperties, ToAccountInfoById, inputCallFinished, inputCallFinishedById, ToAccountPropertiesById, TrustFieldsById, RowDataById, InternalTransferListAcknowledgeResponseById, AuthResponseById } from '../models/internal-transfer/InternalTransfersInfo';
import { ToAccountInfo } from '../models/internal-transfer/ToAccountInfo';
import { IraFields } from '../models/internal-transfer/IraFields';
import { ComponentState } from '../../shared/types/ComponentState';
import { InternalTransferInputResponse } from '../models/internal-transfer/InternalTransferInputResponse';
import { RecurringFields } from '../models/internal-transfer/RecurringFields';
import { TrustFields } from '../models/internal-transfer/TrustFields';
import { EAuthModel } from '../models/internal-transfer/EAuthModel';
import { PositionDetailsForMultiToAccount, toAccountPositionDetailsById } from "../models/internal-transfer/InternalTransferPositions";
import { InternalTransferPositionsResponse } from '../models/internal-transfer/InternalTransferPositionsResponse';
import { InternalTransferPositions} from '../models/internal-transfer/InternalTransferPositions';
import { RestrictionDetails } from "../models/internal-transfer/RestrictionDetails";
import { Attributes } from '../../shared/models/JsonApiWrap';
import { InternalTransferVerifyResponse } from '../models/internal-transfer/InternalTransferVerifyResponse';
import { InternalTransferListAcknowledgeResponse } from '../models/internal-transfer/InternalTransferAcknowledgeResponse';
import { ItTransactionDetails, TransactionFormServiceError } from '../models/form/TransactionForm';
import { InitReleaseActions } from '../../initiate-and-release/actions';
import { DistributionReason } from '../models/internal-transfer/DistributionReason';
import { RemoveHyphenFromAccountPipe } from '../../shared/pipes/remove-hyphen-from-account.pipe';
import { CurrencyPipe } from '@angular/common';
import { getDateWOTimezone } from '../../shared/utilities/datetime-utils';

export const internalTransfersInfoKey = 'internalTransfersInfo';
export interface State extends InternalTransfersInfo { }

export const initialInternalTransfersServiceError: TransactionFormServiceError = {
    status: 0,
    url: '',
    name: '',
    message: '',
    correlationId: '',
    hasError: false,
}

export const initialInternalTransfersInfoState: State = {
    processDate: '',
    stateCd: '',
    isRMDEligible: false,
    rmdAnnualRemainingAmount: '',
    hasPositionsAccess: false,
    hasPositions: false,
    positionsValidIraContributionCode: '',
    acknowledgementArtifactContent: '',
    toAccountInfo: {},
    iraFields: {},
    recurringFields: {},
    trustFields: {},
    accountInfoBanner: {
        masterAccount: '',
        subAccountNumber: '',
        regShortName: '',
        subAccountNameLine1: '',
        subAccountNameLine2: '',
        subAccountNameLine3: '',
        availableCashMMFAmount: '',
        availableOnMarginAmount: '',
        rmdAnnualAmount: '',
        rmdAnnualPaidYearToDateAmount: ''
    },
    warningsList: [],
    hasServiceError: false,
    errorText: '',
    taxCodeList: {},
    pjlsEnabled: false,
    hasWpfaRole: false,
    hasMoveMoneyDataAccess: false,
    isExpandReportingJournal: false,
    canViewJournalWithPositions: false,
    accountRegistration: [],
    totalCashAmount: '',
    totalWithdrawalAmount: '',
    loginId: '',
    source: {
        code: '',
        description: ''
    },
    positionsInfo: {
        hasSelected: false,
        cmtRequestId: 0,
        count: 0,
        list: [],
        totalMarketValue: '',
        selectedMarketValue: '',
        hasError: false,
        serviceError: '',
        lotSelectionMethodDesc: '',
        id: 0,
        stringId: '',
        costBasisMethodSelected: '',
        defaultCostBasisMethod: ''
    },
    requestedDate: '',
    requestedTime: '',
    toAccountState: {},
    inputCallFinished: {},
    positionsLotDetails: {
        costMethod: '',
        totals: {
            totalNoOfPositions: 0,
            totalQuantity: 0,
            totalEstimatedMarketValue: 0
        },
        positions: [],
        // hasError: false,
        // serviceError: '',
        // id: ''
    },
    rowData: {},
    standingAuthCallSucceeded: false,
    toAccountPropertiesById: {},
    multipleToJournalsList: [],
    verifyCallFinished: false,
    verifyCallFinishedWithError: false,
    twePopup: {
        openTwePopup: false,
        totalRows: 0,
        isFirstTimeDistribution: false,
        isTweOnFile: false,
        isNonNAState: false,
        existingAccountFederalTaxWithholdingElection: false,
        existingAccountStateTaxWithholdingElection: false,
        existingAccountFedTaxRate: 0,
        existingAccountStateTaxRate: 0,
        fedTaxRateUserEntered: 0,
        stateTaxRateUserEntered: 0,
        accountDetails: {
            aprOverflowIn: false,
            sloaOverflowInd: false,
            recurringOverflowInd: false,
            returnCode: '',
            errorCode: 0,
            errorMessage: '',
            errorDetails: '',
            totalRowsApr: 0,
            totalRowsSloa: 0,
            totalRowsRecurring: 0,
            hasRecurringTxn: false,
            hasSloaTxn: false,
            accountLevelInfo: {
                trustAccountIndicator: false,
                hasWfpaRoleIndicator: false,
                hasNdfaRoleIndicator: false,
                hasLpfaRoleIndicator: false,
                masterSubAssociationIndicator: false,
                accountRegistrationValidIndicator: false,
                checkRestrictionIndicator: false,
                journalRestrictionIndicator: false,
                moneylinkRestrictionInIndicator: false,
                moneylinkRestrictionOutIndicator: false,
                validBirthDateIndicator: false,
                validTaxpayerIdIndicator: false,
                validRcFrmBptIndicator: false,
                cashMoneyMarketFundAmount: 0,
                availableToBorrowAmount: 0,
                rmdEligibleIndicator: false,
                rmdActiveRecurringIndicator: false,
                customer592Date: '',
                customer702Date: '',
                rmdAnnualCalcAmount: 0,
                rmdAnnualPaidYearToDateAmount: 0,
                rmdAnnualRemainAmount: 0
            },
            cashieringRequestAprs: [],
            recurringRequests: [],
            sloaRequests: []
        },
        regShortName: ''
    },
    isSubmitAndCreate: false,
    multipleAcknowledgeListById: {},
    serviceErrors: initialInternalTransfersServiceError,
    journalAuthResponse: {},
}

var toAccount = '';

export const internalTransfersReducer = createReducer(
    initialInternalTransfersInfoState,
    on(InternalTransfersActions.itLoadToAccountSuccess, (state, response) => {
        const { internalTransferInputResponse } = response;
        toAccount = internalTransferInputResponse.toAccountInfo.accountNumber;
        return {
            ...state,
            toAccountPropertiesById: {
                ...state.toAccountPropertiesById,
                ...updateToAccountProperties(internalTransferInputResponse.toAccountInfo.accountNumber, state.toAccountPropertiesById, internalTransferInputResponse,true) 
            },
            processDate: internalTransferInputResponse.processDate,
            stateCd: internalTransferInputResponse.stateCd,
            isRMDEligible: internalTransferInputResponse.isRMDEligible,
            rmdAnnualRemainingAmount: internalTransferInputResponse.rmdAnnualRemainingAmount,
            hasPositionsAccess: internalTransferInputResponse.hasPositionsAccess,
            hasPositions: internalTransferInputResponse.hasPositions,
            positionsValidIraContributionCode: internalTransferInputResponse.positionsValidIraContributionCode,
            toAccountInfo: {
                ...state.toAccountInfo,
                ...updateToAccountInfo(state.toAccountInfo, internalTransferInputResponse.toAccountInfo, internalTransferInputResponse)
            },
            iraFields: {
                ...state.iraFields,
                ...updateIraFields(internalTransferInputResponse.toAccountInfo.accountNumber, state.iraFields, internalTransferInputResponse.iraFields)
            },
            recurringFields: {
                ...state.recurringFields,
                ...updateRecurringFields(internalTransferInputResponse.toAccountInfo.accountNumber, state.recurringFields, internalTransferInputResponse.recurringFields)
            },
            trustFields: {
                ...state.trustFields,
                ...updateTrustFields(internalTransferInputResponse.toAccountInfo.accountNumber, state.trustFields, internalTransferInputResponse.trustFields)
            },
            accountInfoBanner: internalTransferInputResponse.accountInfoBanner,
            warningsList: internalTransferInputResponse.warningsList,
            errorText: internalTransferInputResponse.errorText,
            taxCodeList: internalTransferInputResponse.taxCodeList,
            pjlsEnabled: internalTransferInputResponse.pjlsEnabled,
            hasWpfaRole: internalTransferInputResponse.hasWpfaRole,
            hasMoveMoneyDataAccess: internalTransferInputResponse.hasMoveMoneyDataAccess,
            inputCallFinished: {
                ...state.inputCallFinished,
                ...updateInputCallFinished(state.inputCallFinished, internalTransferInputResponse.toAccountInfo)
            },
            toAccountState: {
                ...state.toAccountState,
                ...updateToAccountState(internalTransferInputResponse.toAccountInfo.accountNumber, state.toAccountState)
            }
        }
    }),
    on(InternalTransfersActions.itToAccountEntered, (state, { type, ...action }) => {
        return {
            ...state,
            positionLotCallFinished: false,
            verifyCallFinished: false,
            verifyCallFinishedWithError: false,
            toAccountState: {
                ...state.toAccountState, 
                ...updateToAccountState(action.toAccount, state.toAccountState, true)
            },
        }
    }),
    on(InternalTransfersActions.itLoadPositionsSuccessful, (state, { type, ...action }) => {
        const { internalTransferPositionsResponse } = action;
        return {
            ...state,
            positionsLotDetails: {
                ...updatePositionCall(state.positionsLotDetails, internalTransferPositionsResponse, toAccount)
            },
            positionLotCallFinished: true
        }
    }),
    on(InternalTransfersActions.itClearToAccount, (state, { type, ...action }) => {
        const { account } = action;
        return {
            ...state,
            toAccountInfo: {
                ...deleteAccountById(state.toAccountInfo, account)
            },
            positionsLotDetails: {
                ...deletePositionInfoById(state.positionsLotDetails, account)
            },
            iraFields: {
                ...deleteIraFieldsById(state.iraFields, account)
            },
            recurringFields: {
                ...deleteRecurringFieldsById(state.recurringFields, account)
            },
            trustFields: {
                ...deleteTrustFieldsById(state.trustFields, account)
            },
            toAccountState: {
                ...deleteToAccountStateById(state.toAccountState, account)
            },
            inputCallFinished: {},
            toAccountPropertiesById: {
                ...deleteToAccountPropertiesById(state.toAccountPropertiesById, account)
            },
            rowData: {
                ...deleteRowDataById(state.rowData, account)
            }
        };
    }),
    on(InternalTransfersActions.itClearToAccounts, 
        InternalTransfersActions.updateFrequencyIT, 
        (state) => {
        return {
            ...state,
            toAccountInfo: {},
            positionsLotDetails: {
                costMethod: '',
                totals: {
                    totalNoOfPositions: 0,
                    totalQuantity: 0,
                    totalEstimatedMarketValue: 0
                },
                positions: []
            },
            iraFields: {},
            recurringFields: {},
            trustFields: {},
            toAccountState: {},
            inputCallFinished: {},
            toAccountPropertiesById: {},
            rowData: {}
        }
    }),
    on(InternalTransfersActions.itUpdateRowData, (state, { type, ...action }) => {
        return {
            ...state,
            rowData: action
        }
    }),
    on(InternalTransfersActions.verifyListCallSuccessful, (state, action) => {
        const response = action.response;
        return {
            ...state,
            multipleToJournalsList: mapMultipleToJournalsList(response.data),            
            acknowledgementArtifactContent: response.included[0].attributes.acknowledgementArtifactContent,
            verifyCallFinished: true,
            verifyCallFinishedWithError: false,
            twePopup: response.included[0].attributes.twePopup,
            toAccountInfo:{
                ...state.toAccountInfo,
                ...updateToAccountInfo(state.toAccountInfo, response.data[0].attributes.toAccountInfo)
            },
            journalAuthResponse: {
                ...state.journalAuthResponse,
                ...updateAuthResponse(state.journalAuthResponse, mapMultipleToJournalsList(response.data))
            },
            accountInfoBanner: response.data[0].attributes.accountInfoBanner,
            toAccountPropertiesById: mapToAccountPropertiesById(response.data, state.toAccountPropertiesById)        }
    }),
    on(TransactionFormActions.loadReviewPage, state => {
        return {
            ...state,
            verifyCallFinished: false,
            inputCallFinished: {}
        }
    }),
    on(InternalTransfersActions.itLoadToAccountFinishedWithError, (state,response) => {
        const { internalTransferInputResponse } = response;
        return {
            ...state,
            toAccountPropertiesById: {
                ...state.toAccountPropertiesById,
                ...updateToAccountProperties(internalTransferInputResponse.toAccountInfo.accountNumber, state.toAccountPropertiesById, internalTransferInputResponse, false) 
            },
            toAccountState: {
                ...state.toAccountState,
                ...updateToAccountState(internalTransferInputResponse.toAccountInfo.accountNumber, state.toAccountState)
            },
            toAccountInfo:{
                ...state.toAccountInfo,
                ...updateToAccountInfo(state.toAccountInfo, internalTransferInputResponse.toAccountInfo)
            }
        }
    }),
    on(InternalTransfersActions.verifyListCallFinishedWithError, (state, action) => {
        const { response } = action;
        return {
            ...state,
            multipleToJournalsList: mapMultipleToJournalsList(response.data),
            toAccountPropertiesById: mapToAccountPropertiesById(response.data, state.toAccountPropertiesById),
            verifyCallFinished: false,
            verifyCallFinishedWithError: true,
            toAccountInfo:{
                ...state.toAccountInfo,
                ...updateToAccountInfo(state.toAccountInfo, response.data[0].attributes.toAccountInfo)
            },
            journalAuthResponse: {
                ...state.journalAuthResponse,
                ...updateAuthResponse(state.journalAuthResponse, mapMultipleToJournalsList(response.data))
            },
        }
    }),
    on(TransactionFormActions.callInternalTransferListVerify, (state, action) => {
        return {
            ...state,
            toAccountPropertiesById: clearVerifyErrorsForEachToAccount(state.toAccountPropertiesById),
            verifyCallFinished: false,
            verifyCallFinishedWithError: false,
            hasServiceError: false,
        }
    }),
    on(InternalTransfersActions.verifyListCallFailed, (state, err) => {
        return {
            ...state,
            hasServiceError: true,
            }
    }),
    on(TransactionFormActions.loadInternalTransferWithoutVerifyCall, (state, form) => {
        const details = form.transactionDetails as ItTransactionDetails;
        const updateContributionType = mapContributionType(details, state);
        const updateDistributionReason = mapDistributionReason(details, state);
        return {
            ...state,
            toAccountPropertiesById: {
            [details.toAccount]: {
                ...state.toAccountPropertiesById[details.toAccount],
                iraContributionType: updateContributionType?.[0],
                inputIraFields: {
                ...state.toAccountPropertiesById[details.toAccount]?.inputIraFields,
                distributionReason: updateDistributionReason?.[0],
                fedTaxPercent: details.taxWithholdingsFormGroup?.fedTaxPercent,
                stateTaxPercent: details.taxWithholdingsFormGroup?.stateTaxPercent
                },
                journalCashAmount: details.cashAmounts?.[0]?.amount ? details.cashAmounts?.[0]?.amount : Constants.zeroAmount,
            }
            } as ToAccountPropertiesById,
            totalCashAmount: details.cashAmounts?.[0]?.amount ? details.cashAmounts?.[0]?.amount : Constants.zeroAmount,
        }
    }),
    on(InternalTransfersActions.acknowledgeListCallSuccessful, (state , action) => {
        const response = action.response;
        return {
            ...state,
            multipleAcknowledgeListById: mapMultipleAcknowledgeListById(response),
            acknowledgeCallFinished: true,

        }
    }),
    on(InternalTransfersActions.acknowledgeListCallFail, (state, err) => {
        let errMsg = err.message;
        if (err.status === 400 && err.error?.errors && err.error.errors[0]) {
            errMsg = err.error.errors[0].detail;
        }
        return {
            ...state,
            loading: false,
            acknowledgeCallFinished: false,
            serviceError: {
                ...state.serviceErrors,
                status: err.status,
                url: err.url,
                message: err.message,
                errorList: err.error?.errors ?? [],
                hasError: !err.ok
            },
        }
    }),
    on(InitReleaseActions.initReleaseByDraftIdSuccessful, (state, { response, isSloa }) => {
        if (isSloa || response.transactionType !== 'journal') return state;
        let currencyPipe: CurrencyPipe = new CurrencyPipe("en-US");
        let rawToAccountId = response.draftObject.toAccountId?.toString() ?? '';
        let toAccountId = rawToAccountId.slice(0, 4) + '-' + rawToAccountId.slice(4);
        let positionData = response.draftObject.selectedPositionsList?.map(position => {
            let hasLots = position.lots.length > 0;
            let totalCostBasis = position.lots.reduce((acc: any, curr: any) => acc + (parseFloat(curr.costBasis)/parseFloat(curr.quantity)) * parseFloat(curr.selectedQuantity) * Math.sign(parseFloat(curr.costBasis)), 0);
            totalCostBasis = Number(totalCostBasis.toFixed(2));
            return {
                "Symbol": position.symbol,
                "Name": position.fullName,
                "Available shares": `${position.quantity}`,
                "Current price/share": `${currencyPipe.transform(position.price)}`,
                "Shares to move": Math.abs(Number(position.selectedQuantity)),
                "Estimated market value": `${currencyPipe.transform(position.selectedMarketValue * Math.sign(Number(position.selectedQuantity)))}`,
                "Cost basis": position.costBasis,
                lotDetail: position.lots.map((lot: { dateAcquired: string; selectedQuantity: string; holdingPeriodCode: string; purchasePrice: number; lotId: string; lotsToMove: string; costBasis: string; marketValue: number; quantity: number;}) => {return {
                    acquiredDate: getDateWOTimezone(lot.dateAcquired),
                    lotQuantity: lot.quantity,
                    holdingPeriod: lot.holdingPeriodCode === 'S' ? 'Short' : lot.holdingPeriodCode === 'L' ? 'Long' : '',
                    purchaseDate: lot.dateAcquired,
                    purchasePrice: lot.purchasePrice,
                    lotId: lot.lotId,
                    lotsToMove: lot.selectedQuantity,
                    costBasis: lot.costBasis,
                    estimatedMarketValue: `$${lot.marketValue}`,
                    totalCostBasis: `$${(((parseFloat(lot.costBasis)/lot.quantity) * parseFloat(lot.selectedQuantity) * Math.sign(parseFloat(lot.costBasis)))).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                }}),
                cmtSequenceId: position.cmtSequenceId,
                schwabSecurityId: position.schwabSecurityId,
                "valMultiplier": position.multiplier,
                "Total cost basis": hasLots ? `$${totalCostBasis.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}` : 'N/A',
                numberOfLots: position.numberOfLots
            }
        });
        let sharesToMoveTotal = response.draftObject.selectedPositionsList?.reduce((sum, el) => sum += el.selectedQuantity, 0);
        let estimatedMarketValueTotal = response.draftObject.selectedPositionsList?.reduce((sum, el) => sum += el.selectedMarketValue, 0);
        return {
            ...state,
            stateCd: response.draftObject.stateCd ?? '',
            iraFields: {
                [toAccountId]: {
                    isIraTransaction: !!response.draftObject.isIraTransaction,
                    fedTaxPercent: response.draftObject.fedTaxAmount ? `${response.draftObject.fedTaxAmount.toString()}%` : '',
                    stateTaxPercent: response.draftObject.stateTaxAmount ? `${response.draftObject.stateTaxAmount.toString()}%` : '',
                    distributionReasonMap: response.draftObject.distributionReason as DistributionReason ? [response.draftObject.distributionReason as DistributionReason ?? new DistributionReason()] : []
                }
            } as IraFieldsById,
            rowData: {
                [toAccountId]: {
                    positionData: positionData,
                    sharesToMoveTotal: sharesToMoveTotal,
                    estimatedMarketValueTotal: estimatedMarketValueTotal,
                    nodeCostBasis: response.draftObject.selectedCostBasisMethod ?? ''
                }
            } as RowDataById,
            positionsInfo: {
                ...state.positionsInfo,
                cmtRequestId: response.draftObject.stockHandlerId ?? 0
            },
            positionsLotDetails: {
                ...state.positionsLotDetails,
                costMethod: response.draftObject.defaultCostBasisMethod ?? ''
            },
            trustFields: {
                [toAccountId]: {
                    trustIncmPct: response.draftObject.trustIncmPct,
                    trustPrinPct: response.draftObject.trustPrinPct,
                } 
            } as TrustFieldsById,
            toAccountPropertiesById: {
                [toAccountId]: {
                    iraContributionTypeMap: [{
                        code: response.draftObject.iraContributionType?.code,
                        subCode: response.draftObject.iraContributionType?.subCode,
                        year: response.draftObject.iraContributionType?.year,
                        description: response.draftObject.iraContributionType?.description
                      }]
                }
            } as ToAccountPropertiesById
        }
    }),
    on(ReviewPageActions.cancelClicked,
      TransactionFormActions.cancelClicked,
      ConfirmationPageActions.viewTransactionStatusClicked,
      ConfirmationPageActions.createAnotherRequestClicked,
      InitReleaseActions.getInitReleaseList,
     () => {
        return initialInternalTransfersInfoState;
    }),
    on(ReviewPageActions.editClicked, (state) => {
        return {
            ...state,
            serviceError: '',
            isSubmitAndCreate: false
        }
    })
);

function clearVerifyErrorsForEachToAccount(toAccountPropertiesById: ToAccountPropertiesById) {
    const byId: ToAccountPropertiesById = {};
    Object.entries(toAccountPropertiesById).forEach( ([key, toAccountPropertiesById]) => {
        const ToAccountProperties: ToAccountProperties = {
            ...toAccountPropertiesById,
            hasError: false,
            verifyErrorText : ""
        }
        byId[key] = ToAccountProperties;
    });
    return byId;
}

function mapMultipleToJournalsList(journals: Attributes<InternalTransferVerifyResponse>[]): InternalTransferVerifyResponse[] {
    let journalsList: InternalTransferVerifyResponse[] = []
    journals.forEach((journal) => {
        journalsList.push(journal.attributes as InternalTransferVerifyResponse)
    })
    return journalsList;
}

function mapMultipleAcknowledgeListById(ackListResponse: InternalTransferListAcknowledgeResponse) {
    const byId: InternalTransferListAcknowledgeResponseById = {};
    ackListResponse.data.forEach((response) => {
        const id = response.id.toString();
        byId[id.slice(0, 4) + '-' + id.slice(4)] = response.attributes;
    });
    return byId;
}

function mapToAccountPropertiesById(journals: Attributes<InternalTransferVerifyResponse>[], toAccountPropertiesById: ToAccountPropertiesById): ToAccountPropertiesById {
    const byId: ToAccountPropertiesById = {};
    journals.forEach((journal) => {
        if (journal.attributes.hasError) {
            const ToAccountProperties: ToAccountProperties = {
                ...toAccountPropertiesById[journal.attributes.toAccountInfo.accountNumber],
                hasError: true,
                verifyErrorText : journal.attributes.messageInfo.atsSystemErrors.length > 0 ?
                    Constants.createRequestServiceError : journal.attributes.messageInfo.errorList[0]?.messageText,
                isThirdParty: journal.attributes.isThirdParty
            };
            byId[journal.attributes.toAccountInfo.accountNumber] = {...ToAccountProperties};
        }
        else {
            byId[journal.attributes.toAccountInfo.accountNumber] = {
                ...toAccountPropertiesById[journal.attributes.toAccountInfo.accountNumber],
                isThirdParty: journal.attributes.isThirdParty,
                shouldShowStateTax: hasStateTax(
                    journal.attributes.iraFields.nraAccountIndicator,
                    journal.attributes.iraFields.stwProcessCode as StwProcessCode
                )
            }
        }
    })
    return byId;
}

function deleteRowDataById(rowDataById: RowDataById, accountNumber: string): RowDataById {
    const byId: RowDataById = {};
    Object.entries(rowDataById).forEach(([key, rowData]) => {
        if (key !== accountNumber) {
            byId[key] = { ...rowData };
        }
    });
    return byId;
}

function deleteAccountById(toAccounts: ToAccountInfoById, accountNumber: string): ToAccountInfoById {
    
    const byId: ToAccountInfoById = {};
    Object.entries(toAccounts).forEach(([key, accountInfo]) => {
        if (key !== accountNumber) {
            byId[key] = { ...accountInfo };
        }
    });
    return byId;
}

function deleteToAccountStateById(toAccountState:ComponentStateById,accountNumber:string): ComponentStateById{
    const byId: ComponentStateById = {};
    Object.entries(toAccountState).forEach(([key, toAccountState]) => {
        if (key !== accountNumber) {
            byId[key] = { ...toAccountState };
        }
    });
    return byId;
}

function deleteToAccountPropertiesById(toAccountPropertiesById:ToAccountPropertiesById,accountNumber:string):ToAccountPropertiesById{
    const byId: ToAccountPropertiesById = {};
    Object.entries(toAccountPropertiesById).forEach(([key, toAccountPropertiesById]) => {
        if (key !== accountNumber) {
            byId[key] = { ...toAccountPropertiesById };
        }
    });
    return byId;
}

function deleteIraFieldsById(iraFields:IraFieldsById,accountNumber:string): IraFieldsById{
    const byId: IraFieldsById = {};
    Object.entries(iraFields).forEach(([key, iraFields]) => {
        if (key !== accountNumber) {
            byId[key] = { ...iraFields };
        }
    });
    return byId;

}

function deleteRecurringFieldsById(recurringFields:RecurringFieldsById,accountNumber:string): RecurringFieldsById{
    const byId: RecurringFieldsById = {};
    Object.entries(recurringFields).forEach(([key, recurringFields]) => {
        if (key !== accountNumber) {
            byId[key] = { ...recurringFields };
        }
    });
    return byId;
}

function deleteTrustFieldsById(trustFields:TrustFieldsById,accountNumber:string): TrustFieldsById{
    const byId: TrustFieldsById = {};
    Object.entries(trustFields).forEach(([key, trustFields]) => {
        if (key !== accountNumber) {
            byId[key] = { ...trustFields };
        }
    });
    return byId;
}

function deletePositionInfoById(positionsLotDetails: InternalTransferPositions, accountNumber: string): InternalTransferPositions {
    // Rebuild the remaining to-account map first so removing the last account clears the positions payload instead of leaving stale rows behind.
    const positions = positionsLotDetails.positions
        .map(position => {
            const byId: toAccountPositionDetailsById = {};
            Object.entries(position.toAccountPositionDetails).forEach(([key, toAccountDetail]) => {
                if (key !== accountNumber) {
                    byId[key] = { ...toAccountDetail };
                }
            });
            return {
                ...position,
                toAccountPositionDetails: byId
            };
        })
        .filter(position => Object.keys(position.toAccountPositionDetails).length > 0);

    if (positions.length < 1) {
        return {
            ...positionsLotDetails,
            costMethod: '',
            positions: [],
            totals: {
                totalEstimatedMarketValue: 0,
                totalQuantity: 0,
                totalNoOfPositions: 0,
            }
        }
    } else {
        return {
            ...positionsLotDetails,
            positions
        }
    }
}

function updatePositionCall(currentState:InternalTransferPositions, internalTransferPositionsResponse: InternalTransferPositionsResponse, toAccount:string ): InternalTransferPositions{
    return {
        costMethod: currentState.costMethod ? currentState.costMethod : internalTransferPositionsResponse.costMethod,
        totals: {
            totalEstimatedMarketValue: currentState.totals?.totalEstimatedMarketValue ? currentState.totals?.totalEstimatedMarketValue : internalTransferPositionsResponse.totals.totalEstimatedMarketValue,
            totalQuantity: currentState.totals?.totalQuantity ? currentState.totals?.totalQuantity :  internalTransferPositionsResponse.totals.totalQuantity,
            totalNoOfPositions: currentState.totals?.totalNoOfPositions ? currentState.totals?.totalNoOfPositions : internalTransferPositionsResponse.totals.totalNoOfPositions
        },
        positions: internalTransferPositionsResponse.positions.map(responsePosition => {
            const currentStateIndex = currentState.positions.findIndex(existingPosition => existingPosition.schwabSecurityId === responsePosition.schwabSecurityId);
            if (currentStateIndex === -1){
                const toAccountDetail: toAccountPositionDetailsById = {};
                const restriction: RestrictionDetails = {
                    isRestricted: responsePosition.restriction.isRestricted,
                    restrictionText: responsePosition.restriction.restrictionText
                };
                const AccountDetail = {
                    restriction: restriction,
                    hasServiceError: internalTransferPositionsResponse.hasError,
                    serviceError: internalTransferPositionsResponse.serviceError
                };
                toAccountDetail[toAccount] = { ...AccountDetail};
                const position: PositionDetailsForMultiToAccount = {
                    symbol: responsePosition.symbol,
                    symbolName: responsePosition.symbolName,
                    totalQuantity: responsePosition.totalQuantity,
                    numberOfLots: responsePosition.numberOfLots,
                    currentPricePerShare: responsePosition.currentPricePerShare,
                    costBasis: responsePosition.costBasis,
                    estimatedMarketValue: responsePosition.estimatedMarketValue,
                    isMutualFund: responsePosition.isMutualFund,
                    lots: responsePosition.lots,
                    schwabSecurityId: responsePosition.schwabSecurityId,
                    cmtSequenceId: responsePosition.cmtSequenceId,
                    valMultiplier: responsePosition.valMultiplier,
                    quantity: responsePosition.quantity,
                    setToAverage: responsePosition.setToAverage,
                    toAccountPositionDetails: toAccountDetail
                }
                return position;
            }
            else {
                var toAccountDetail: toAccountPositionDetailsById = {};
                const restriction: RestrictionDetails = {
                    isRestricted: responsePosition.restriction.isRestricted,
                    restrictionText: responsePosition.restriction.restrictionText
                };
                const AccountDetail = {
                    restriction: restriction,
                    hasServiceError: internalTransferPositionsResponse.hasError,
                    serviceError: internalTransferPositionsResponse.serviceError
                };
                toAccountDetail = {...currentState.positions[currentStateIndex].toAccountPositionDetails}
                toAccountDetail[toAccount] = {...AccountDetail};
                const position: PositionDetailsForMultiToAccount = {
                    ...currentState.positions[currentStateIndex],
                    toAccountPositionDetails: toAccountDetail
                }
                if (position.valMultiplier === 1 && position.valMultiplier !== responsePosition.valMultiplier) {
                    position.valMultiplier = responsePosition.valMultiplier;
                }
                return position;
            }
        })
    };
}

function hasStateTax(nraIndicator: boolean, stwProcessCode: StwProcessCode): boolean {
    if (nraIndicator) {
        return true;
    } else if (stwProcessCode) {
        return stwProcessCode !== 'N';
    } else {
        return false;
    }
}
function updateToAccountInfo(currentState: ToAccountInfoById, toAccountInfo: ToAccountInfo, internalTransferInputResponse?: InternalTransferInputResponse): ToAccountInfoById {
    const byId: ToAccountInfoById = {};
    const toAccountHasPtrsOffer = toAccountInfo.isTrust && !internalTransferInputResponse?.isTrustNonPTRSAccount;
    const defaultToIncome = toAccountHasPtrsOffer ? '0%' : '100%';
    const defaultToPrincipal = toAccountHasPtrsOffer ? '100%' : '0%';
    const accountInfo: ToAccountInfo = {
        accountNumber: toAccountInfo.accountNumber,
        registrationType: toAccountInfo.registrationType,
        regTypeShortName: toAccountInfo.regTypeShortName,
        productCode: toAccountInfo.productCode,
        isIdentical: internalTransferInputResponse?.isIdentical ?? false,
        isRelated: toAccountInfo.isRelated,
        isIraAccount: toAccountInfo.isIraAccount,
        isTrust: toAccountInfo.isTrust,
        toIncome: toAccountInfo.toIncome.length !== 0 ? toAccountInfo.toIncome : defaultToIncome,
        toPrincipal: toAccountInfo.toPrincipal.length !== 0 ? toAccountInfo.toPrincipal : defaultToPrincipal,
        accountRegistration: toAccountInfo.accountRegistration,
        availableCashMmf: toAccountInfo.availableCashMmf
    };
    byId[toAccountInfo.accountNumber] = { ...currentState[toAccountInfo.accountNumber], ...accountInfo };
    return byId;
}

function updateInputCallFinished(currentState: inputCallFinishedById, toAccountInfo: ToAccountInfo): inputCallFinishedById {
    const byId: inputCallFinishedById = {};
    const inputCallFinished: inputCallFinished = {inputCallFinished:true}
    byId[toAccountInfo.accountNumber] = { ...currentState[toAccountInfo.accountNumber], ...inputCallFinished };
    return byId;
}

function updateIraFields(toAccount: string, currentState: IraFieldsById, iraFields: IraFields): IraFieldsById {
    const byId: IraFieldsById = {};
    const iraInfo: IraFields = {
        isIraTransaction: iraFields.isIraTransaction,
        isAccountTaxable: iraFields.isAccountTaxable,
        hasActiveTaxElections: iraFields.hasActiveTaxElections,
        fedTaxPercent: iraFields.fedTaxAmount,
        fedTaxAmount: '',
        isWithholdFedTax: iraFields.isWithholdFedTax,
        stateTaxPercent: iraFields.fedTaxAmount,
        stateTaxAmount: '',
        isWithholdStateTax: iraFields.isWithholdStateTax,
        stateTypeIndicator: iraFields.stateTypeIndicator,
        stwProcessCode: iraFields.stwProcessCode,
        stateTaxAttentionMessage: iraFields.stateTaxAttentionMessage,
        stateTaxAttentionRequired: iraFields.stateTaxAttentionRequired,
        isCashieringIRAAgreementOpened: iraFields.isCashieringIRAAgreementOpened,
        rmdAnnualAmount: iraFields.rmdAnnualAmount,
        rmdAnnualPaidYearToDateAmount: iraFields.rmdAnnualPaidYearToDateAmount,
        isRmdToDisplay: iraFields.isRmdToDisplay,
        taxValueOriginMessage: iraFields.taxValueOriginMessage,
        distributionReason: iraFields.distributionReason,
        distributionReasonMap: iraFields.distributionReasonMap,
        nraAccountIndicator: iraFields.nraAccountIndicator
    };
    byId[toAccount] = { ...currentState[toAccount], ...iraInfo };
    return byId;
}
function updateToAccountState(accountNumber: string, toAccountState: ComponentStateById, isLoading: boolean = false): ComponentStateById {
    const byId: ComponentStateById = {};
    const componentState: ComponentState = {
        loading: isLoading,
        error: '',
        hasError: false
    }
    byId[accountNumber] = { ...toAccountState[accountNumber], ...componentState };
    return byId;
}
function updateToAccountProperties(accountNumber: string, currentState: ToAccountPropertiesById, internalTransferInputResponse: InternalTransferInputResponse,isToAccountSucess: boolean): ToAccountPropertiesById {
    const byId: ToAccountPropertiesById = {};
    const toAccountProperties: ToAccountProperties = {
        iraContributionTypeMap: internalTransferInputResponse.iraContributionTypeMap,
        positionsValidIraContributionCode: internalTransferInputResponse.positionsValidIraContributionCode,
        isTrustNonPTRSAccount: internalTransferInputResponse.isTrustNonPTRSAccount,
        isIdentical: false,
        serviceError: '',
        eauthAccess: false,
        clientAuthorizationNeeded: false,
        isRMDToDisplay: false,
        isThirdParty: false,
        eAuthModel: new EAuthModel,
        journalCashAmount: '',
        iraContributionType: {
            code: '',
            subCode: '',
            year: '',
            description: ''
        },
        pendReasons: [],
        isPendingOnlyForCTWE: false,
        isPendingForLPND: false,
        messageInfo: {
            errorList: [],
            warningList: [],
            atsSystemErrors: []
        },
        trustTaxCode: '',
        nickname: '',
        hasError: false,
        taxId: '',
        caseId: '',
        submitAndCreateSloaId: '',
        status: {
            code: '',
            description: ''
        },
        cashieringReqId: 0,
        cashieringReqSecondaryId: 0,
        isPendingForCTWE: false,
        eAuthTransactionScoreCardLogMessage: '',
        eAuthSloaScoreCardLogMessage: '',
        inputCallFinished: true,
        inputCallSuccessful: true,
        positionLotCallFinished: false,
        verifyCallFinished: false,
        acknowledgeCallFinished: false,
        inputIraFields: {
            isIraTransaction: internalTransferInputResponse.iraFields.isIraTransaction,
            isAccountTaxable: internalTransferInputResponse.iraFields.isAccountTaxable,
            hasActiveTaxElections: internalTransferInputResponse.iraFields.hasActiveTaxElections,
            fedTaxPercent: internalTransferInputResponse.iraFields.fedTaxAmount,
            fedTaxAmount: '',
            isWithholdFedTax: internalTransferInputResponse.iraFields.isWithholdFedTax,
            stateTaxPercent: internalTransferInputResponse.iraFields.stateTaxAmount,
            stateTaxAmount: '',
            stateTaxAttentionRequired: internalTransferInputResponse.iraFields.stateTaxAttentionRequired,
            isWithholdStateTax: internalTransferInputResponse.iraFields.isWithholdStateTax,
            stateTypeIndicator: internalTransferInputResponse.iraFields.stateTypeIndicator,
            stwProcessCode: internalTransferInputResponse.iraFields.stwProcessCode,
            stateTaxAttentionMessage: internalTransferInputResponse.iraFields.stateTaxAttentionMessage,
            isCashieringIRAAgreementOpened: internalTransferInputResponse.iraFields.isCashieringIRAAgreementOpened,
            rmdAnnualAmount: internalTransferInputResponse.iraFields.rmdAnnualAmount,
            rmdAnnualPaidYearToDateAmount: internalTransferInputResponse.iraFields.rmdAnnualPaidYearToDateAmount,
            isRmdToDisplay: internalTransferInputResponse.iraFields.isRmdToDisplay,
            taxValueOriginMessage: internalTransferInputResponse.iraFields.taxValueOriginMessage,
            distributionReason: internalTransferInputResponse.iraFields.distributionReason,
            distributionReasonMap: internalTransferInputResponse.iraFields.distributionReasonMap,
            nraAccountIndicator: internalTransferInputResponse.iraFields.nraAccountIndicator
        },
        loadToAccountErrorText: isToAccountSucess ? '' : internalTransferInputResponse.errorText,
        verifyErrorText: '',
        shouldShowStateTax: hasStateTax(
            internalTransferInputResponse.iraFields.nraAccountIndicator,
            internalTransferInputResponse.iraFields.stwProcessCode as StwProcessCode
        ),
        netCashAmount: '',
        isSubmitAndCreate: false,
        txnCode: ''
    }
    byId[accountNumber] = { ...currentState[accountNumber], ...toAccountProperties };
    return byId;
}
function updateRecurringFields(accountNumber: string, currentState: RecurringFieldsById, recurringFields: RecurringFields): RecurringFieldsById {
    const byId: RecurringFieldsById = {};
    byId[accountNumber] = { ...currentState[accountNumber], ...recurringFields };
    return byId;
}
function updateTrustFields(accountNumber: string, currentState:TrustFieldsById, trustFields: TrustFields): TrustFieldsById {
    const byId: TrustFieldsById = {};
    byId[accountNumber] = { ...currentState[accountNumber], ...trustFields };
    return byId;
}
function updateAuthResponse(currentState: AuthResponseById, journals: InternalTransferVerifyResponse[]): AuthResponseById {
    let hyphenPipe = new RemoveHyphenFromAccountPipe();
    
    const byId: AuthResponseById = {};
    journals.forEach((journal) => {
        let accountNumber = hyphenPipe.transform(journal.toAccountInfo.accountNumber);
        byId[accountNumber] = { ...currentState[accountNumber], ...journal.journalAuthResponse};
    })
    return byId;
}
function mapContributionType(details: ItTransactionDetails, state: State) {
  return details.toAccounts?.map(account => {
    const contributionTypeData = state.toAccountPropertiesById[account.toAccount]?.iraContributionTypeMap || [];
    const contributionTypeSelected = contributionTypeData.find(item => item.description === account.iraContributionType);
    return contributionTypeSelected
      ? { code: contributionTypeSelected.code, subCode: contributionTypeSelected.subCode, year: contributionTypeSelected.year, description: contributionTypeSelected.description }
      : { code: '', subCode: '', year: '', description: '' };
  });
}

function mapDistributionReason(details: ItTransactionDetails, state: State) {
  return details.toAccounts?.map(account => {
    const distributionReasonData = state.toAccountPropertiesById[account.toAccount]?.inputIraFields.distributionReasonMap || [];
    const distributionReasonSelected = distributionReasonData.find(item => item.description === account.iraDistributionType);
    return distributionReasonSelected
      ? { code: distributionReasonSelected.code, subCode: distributionReasonSelected.subCode, isTaxExempt: distributionReasonSelected.isTaxExempt, description: distributionReasonSelected.description }
      : { code: '', subCode: '', isTaxExempt: '', description: '' };
  });
}
